export default function getSubset(data, filter, referenceDate = new Date()) {

  const getNDate = n => {
    let date = new Date(referenceDate);
    date.setDate(date.getDate() - n);
    return date
  }

  let yearAgo = getNDate(365)
  let monthAgo = getNDate(30)
  let weekAgo = getNDate(7)


  if (filter === "year") {
    return data.filter(x => x.datetime > yearAgo)
  } else if (filter === "month") {
    return data.filter(x => x.datetime > monthAgo)
  } else if (filter === "week") {
    return data.filter(x => x.datetime > weekAgo)
  } else {
    return data.filter(x => x.year == filter)
  }
}
